// CSS
// import '../scss/vendor.scss';
import '../scss/app.scss';

// JS
import * as bootstrap from 'bootstrap';
import {initAjaxForm, initAjaxLink} from './ajax';
import {initBoxLink} from './box-link';
import {initCookieNotice} from './cookies';
import {initMemberApplicant} from './applicant';
import './breakpoint';

// Ajax form
initAjaxForm();
$(document).on('change', '.ajax-form input, .ajax-form select', function (e) {
  $(this).closest('form').submit();
});

// Ajax link
initAjaxLink();

// Box link
initBoxLink();

// Cookie notice
initCookieNotice();

// Member applicant
initMemberApplicant();

// global, shared javascript
$(document).ajaxSend(function (event, request, settings) {
  // add ajax class only when request is not resolved quickly (to show loading effect)
  setTimeout(function () {
    if (request.readyState != 4) {
      $('body').addClass('ajax');
    }
  }, 300);
  // setting headers
  let csrfToken = document
    .querySelector('meta[name="X-CSRF-Token"]')
    .getAttribute('content');
  request.setRequestHeader('X-CSRF-Token', csrfToken);
});

$(document).ajaxComplete(function (event, request, settings) {
  $('body').removeClass('ajax');
});

// logo
$(window).scroll(function (event) {
  var scroll = $(window).scrollTop();
  if (scroll > 300) {
    $('.logo').addClass('v2');
  } else {
    $('.logo').removeClass('v2');
  }
});

$(document).ready(function (e) {

  $(document).on('breakpoint', function(e, x) {
    if (e.originalEvent.isMobile) {
      $('.active-ancestor').addClass('clicked');
      $(document).on('click', '.has-subnav:not(".clicked") > a', function(e) {
        e.preventDefault();
        $('.clicked').removeClass('clicked');
        $(this).parents('.has-subnav').addClass('clicked');
      });

    }
  });

  // bootstrap collapse init
  $('.more-close-title').hide();
  $('.more-open-title').show();
  $('.collapse')
    .collapse('hide')
    .on('hide.bs.collapse', function() {
      $('.more-close-title').hide();
      $('.more-open-title').show();
    })
    .on('show.bs.collapse', function() {
      $('.more-open-title').hide();
      $('.more-close-title').show();
    });

  // overlay items
  let elementGridItems = $('.grid-item-inner');
  if (elementGridItems.length) {
    elementGridItems
      .on('mouseenter', function (e) {
        $('> .overlay-item', this).show();
      })
      .on('mouseleave', function (e) {
        $('.overlay-item').hide();
      });
  }
  // flash message
  let elementFlashMessage = $('.flash-message');
  if (elementFlashMessage.length) {
    setTimeout(function() {
      elementFlashMessage.addClass('hidden');
    }, 10000);
  }

  // modals
  $('#multiple-logins').modal('show');
});
